(function() {
    'use strict';
    var RequestUpdateCreditDetailsCtrl = function($scope, $compile,ajaxCall, xmsNotificationFactory) {
        console.log("Inside RequestUpdateCreditDetailsCtrl");
        $scope.ngModel = {};
        console.log("$scope.creditDetailsModel"+$scope.ngModel);

        $scope.fnRequestWatcher = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/creditDetails/requestWatcher";
    
             var data    = $scope.ngModel;

            ajaxCall.getData(ajaxUrl,data).then(
                function(result) {
                    
                    var alertMessage = "You have been successfully added as a watcher.";
                    xmsNotificationFactory.addObj({id: "updateCreditDetails", type: "success", bodyHtml: alertMessage, timeout:5});
                     $scope.cancel();
                },
                function(result) {
                    console.log("failure ");
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "updateCreditDetails", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $scope.cancel();

                }
            );
            $event.preventDefault();
        }

        $scope.fnRequestForUpdateCreditDetails = function($event) {

            $event.preventDefault();
            var ajaxUrl = WEBAPP_PATH + "/creditDetails/requestForCreditDetailsUpdate?";
            var data    = $scope.ngModel;

            console.log("data .."+data)
 
            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    /*console.log("successul ");
                    console.log("result.data"+result);
                    for(var key in result) {
                        console.log("key::"+key)
                        var obj = result[key];
                        console.log("object::"+obj)
                    }*/
                    var alertMessage = "Credit Details Update Requested.";
                    xmsNotificationFactory.addObj({id: "updateCreditDetails", type: "success", bodyHtml: alertMessage, timeout:5});
                     $scope.cancel();
                },
                function(result) {
                    console.log("failure ");
                    var alertMessage = "Error occurred. Please try again later.";
                    xmsNotificationFactory.addObj({id: "updateCreditDetails", type: "danger", bodyHtml: alertMessage, timeout:10});
                    $scope.cancel();

                }
            );
            $event.preventDefault();
        }
    }
    RequestUpdateCreditDetailsCtrl.$inject = ['$scope', '$compile', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').controller('RequestUpdateCreditDetailsCtrl', RequestUpdateCreditDetailsCtrl);
}());
